import type { ISetting } from '@xbl/types'
import { settingList } from '@/services'
import { useCallback, useState } from 'react'

export default function useMcat() {
  const [setting, setSetting] = useState<ISetting[]>([])

  const getSetting = useCallback(async () => {
    const res = await settingList()
    setSetting(res.data)
  }, [])

  return {
    setting,
    getSetting
  }
}
